function FaceBookIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="24"
      fill="none"
      viewBox="0 0 12 24"
    >
      <path
        fill="currentColor"
        d="M11.214 13.516l.622-4.096h-3.89V6.764c0-1.12.542-2.213 2.284-2.213H12V1.064S10.395.787 8.86.787C5.655.787 3.562 2.75 3.562 6.3V9.42H0v4.096h3.562v9.9a13.97 13.97 0 002.191.171c.746 0 1.477-.058 2.192-.171v-9.9h3.269z"
      ></path>
    </svg>
  );
}

export default FaceBookIcon;
